export const PossibleRoles = {
  ADMIN: 'Admin',
  BASIC: 'Basic',
};
